export default __webpack_public_path__ + "static/media/ses3.2db15af0.png";